import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import Handler from '../Checkout/Handler';
import type Discussion from 'flarum/common/models/Discussion';

export default function () {
  const canPayToBump = function (discussion: Discussion) {
    const tags = discussion.tags() || [];
    const ptbTags = tags.filter((tag) => tag && tag.blomstraPtbProduct());

    const actor = app.session?.user;
    const author = discussion.user();

    // Disallow when nog logged in or no Pay to Bump tags are on this discussion.
    if (!actor || ptbTags.length === 0) return false;

    // Allow bumping your own.
    if (actor.id() === (author && author.id())) return true;

    // Allow bumping discussions by others.
    if (ptbTags.find((tag) => tag && tag.blomstraPtbBumpOthers() === true)) return true;

    return false;
  };

  const payToBump = function (discussion: Discussion) {
    const handler = new Handler('ptb', {
      discussion: discussion.id(),
    });

    handler.checkout();
  };

  extend(DiscussionControls, 'userControls', function (items, discussion) {
    if (canPayToBump(discussion)) {
      items.add(
        'bump',
        <Button icon="fas fa-sort-numeric-up" onclick={() => payToBump(discussion)}>
          {app.translator.trans('floxum-payments.forum.pay-to-bump.purchase-control')}
        </Button>
      );
    }
  });
}
